import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { renewalDetails } from "../../../utils/router/constant";
import { formatAmount, setParamsInURL } from "../../../utils/helper";
import PolicyEraImg from "../../../assets/images/PolicyEra.jpeg";
import { Row, Col } from "react-bootstrap";
import Button from "../../../components/common/button";
import Card from "../../../components/cardView";

const RenewalCard = ({ renewalData }) => {
  const location = useLocation();
  const nav = useNavigate();

  const handleRenew = async () => {
    const paramObject = {
      entityid: renewalData.product_id,
      orderId: renewalData.entityid,
    };
    const params = await setParamsInURL(location, paramObject);
    nav(`${renewalDetails}?${params}`);
  };

   const getCoverValue = (orderData) => {
      let cover = 0;
  
      if (orderData && orderData.variant_json) {
        const data = JSON.parse(orderData.variant_json);
        const firstId = Object.keys(data)[0];
  
        if (firstId && data[firstId]?.cover) {
          cover = data[firstId].cover;
        }
      }
      return formatAmount(cover);
    };
  

  const headerContent = (
    <>
      {renewalData.product_details.map((variant, index) => (
        <img
          key={index}
          src={variant.media_url ? variant.media_url : PolicyEraImg}
          className="product-variant-image"
          alt="Product Variant"
        />
      ))}
    </>
  );

  const bodyContent = (
    <div className="renewal-card-middle">
      <span>#{renewalData?.code}</span>
      <div className="middle-subtitle">{renewalData?.name}</div>
      <Row className="info-wrappper">
        <Col xs={4}>
          <div className="info-amount-title">Cover</div>
          <div className="info-amount-value">
          {getCoverValue(renewalData)}
          </div>
        </Col>
        <Col xs={4}>
          <div className="info-amount-title">Premium</div>
          <div className="info-amount-value">
            {formatAmount(renewalData?.gross_amount)}
          </div>
        </Col>
        <Col xs={4}>
          <div className="info-amount-title-red">
            {renewalData?.renewal_remaining_days
              ? "Renewal In"
              : renewalData?.renewal_grace_remaining_days
              ? "Lapse In"
              : "N/A"}
          </div>
          <div className="info-amount-value">
            {renewalData?.renewal_remaining_days
              ? `${renewalData.renewal_remaining_days} Days`
              : renewalData?.renewal_grace_remaining_days
              ? `${renewalData.renewal_grace_remaining_days} Days`
              : "N/A"}
          </div>
        </Col>
      </Row>
    </div>
  );

  const footerContent = (
    <div className="insurance--footer--button">
      <Button
        className="renew-button"
        type="button"
        variant="primary"
        label="Renew Now"
        onClick={handleRenew}
      />
    </div>
  );

  return (
    <Card
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
    />
  );
};

export default RenewalCard;
